export default __webpack_public_path__ + "static/media/home-photography-img-04.a28f4fc8.jpg";